function PrinterestIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1106_2262)">
        <path
          d="M27.6544 0H4.4771C3.32453 0 2.21918 0.459739 1.40419 1.27808C0.589202 2.09642 0.131348 3.20633 0.131348 4.36364L0.131348 27.6364C0.131348 28.7937 0.589202 29.9036 1.40419 30.7219C2.21918 31.5403 3.32453 32 4.4771 32H27.6544C28.807 32 29.9124 31.5403 30.7274 30.7219C31.5423 29.9036 32.0002 28.7937 32.0002 27.6364V4.36364C32.0002 3.20633 31.5423 2.09642 30.7274 1.27808C29.9124 0.459739 28.807 0 27.6544 0ZM17.6031 20.4545C16.3664 20.4545 15.2057 19.7836 14.8073 19.0218C14.8073 19.0218 14.1428 21.6691 14.0034 22.18C13.5072 23.9836 12.0514 25.7909 11.9373 25.9382C11.9195 25.9621 11.8951 25.9802 11.8672 25.9903C11.8392 26.0004 11.809 26.0021 11.7801 25.9951C11.7512 25.9882 11.725 25.9729 11.7046 25.9511C11.6843 25.9294 11.6708 25.9021 11.6657 25.8727C11.6349 25.6436 11.2637 23.3655 11.7001 21.5091L13.1686 15.2473C12.9209 14.6739 12.7974 14.0541 12.8065 13.4291C12.8065 11.7273 13.7897 10.4564 15.0137 10.4564C16.0531 10.4564 16.5565 11.24 16.5565 12.1818C16.5565 13.2309 15.8901 14.8018 15.5461 16.2582C15.2582 17.4764 16.1545 18.4709 17.3568 18.4709C19.5297 18.4709 20.9783 15.6745 20.9783 12.3618C20.9783 9.84545 19.2907 7.96 16.2179 7.96C12.7485 7.96 10.5847 10.5582 10.5847 13.4545C10.5847 14.4564 10.8798 15.1618 11.3398 15.7073C11.5516 15.9582 11.5824 16.06 11.5045 16.3473C11.4502 16.56 11.3235 17.0745 11.271 17.2691C11.2616 17.3314 11.2375 17.3905 11.2006 17.4414C11.1638 17.4924 11.1152 17.5337 11.0591 17.5618C11.003 17.59 10.941 17.6042 10.8783 17.6033C10.8156 17.6023 10.754 17.5862 10.6988 17.5564C9.09989 16.9091 8.35568 15.1509 8.35568 13.1764C8.35568 9.91273 11.0971 6 16.5329 6C20.9004 6 23.7759 9.17273 23.7759 12.58C23.7759 17.0909 21.2807 20.4545 17.6031 20.4545Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1106_2262">
          <rect
            width="31.8688"
            height="32"
            fill="white"
            transform="translate(0.131348)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PrinterestIcon;
